import React from 'react';
import { AttachedFilesBaseSortableList } from '../../AttachedFilesBase';
import { IFileItem } from '../../../../types/api/FileItem';
import { PostsEditorWithUpload } from './PostsEditorWithUpload';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { SonForm } from '../../../Form2';
import { AnyParameter } from '../../../Form2/types/SonForm';

type PostsEditorWithUploadAndAttachedFiles = PostsEditorWithUpload & {
  attachments?: IFileItem[];
  attachedFileUpdateOrder?: SonForm<AnyParameter>;
};

/**
 * Wrapper for the Posts RichText Editor with Upload and the websocket connected AttachedFiles
 */
export function PostsEditorWithUploadAndAttachedFiles({
  form,
  attachments,
  attachedFileUpdateOrder,
  postId,
  type,
}: PostsEditorWithUploadAndAttachedFiles) {
  const { t } = useSonTranslation('Posts');

  return (
    <>
      <PostsEditorWithUpload postId={postId} form={form} type={type} autoFocus />
      {attachments && attachments.length > 0 && (
        <div className="posts__attachements-container-edit">
          <AttachedFilesBaseSortableList
            headline={t('default.attachedfiles.headline.uploaded')}
            attachedFileUpdateOrder={attachedFileUpdateOrder}
            attachments={attachments}
            hideNoAttachmentsMessage
            backgroundTransparent
            postId={postId}
          />
        </div>
      )}
    </>
  );
}
